import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import { WithStyles, withStyles, createStyles } from '@material-ui/core';

import { getIsFilterPopoverOpen } from 'ha/pages/Search/selectors';

interface Props {
  isFilterPopoverOpen: boolean;
  children: React.ReactElement<{ className: string }>;
}

const styles = createStyles({
  fade: {
    opacity: 0.3,
  },
});

const Fader: React.FC<Props & WithStyles<typeof styles>> = ({
  isFilterPopoverOpen,
  children,
  classes,
}) =>
  React.cloneElement(children, {
    className: cx(children.props.className, {
      [classes.fade]: isFilterPopoverOpen,
    }),
  });

export default connect(state => ({
  isFilterPopoverOpen: getIsFilterPopoverOpen(state),
}))(withStyles(styles)(Fader));
